// extracted by mini-css-extract-plugin
export default {"melodyVideo":"dK-z","isFullWidth":"eK-z","landingPageVideo":"fK-z","play":"gK-z","iframeVideo":"hK-z","playHidden":"iK-z","fullwidth":"jK-z"};